import { Component, OnInit } from '@angular/core';
import { PriceRequestService } from '@markant-platform/cartridge/data-access';
import { BehaviorSubject, firstValueFrom, Observable, Subject } from 'rxjs';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { PriceRequestsDto } from '@markant-platform/cartridge/model';
import { PlatformWidgetComponent } from '../platform-widget.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'markant-platform-price-requests-widget',
  templateUrl: 'price-requests-widget.component.html',
})
export class PriceRequestsWidgetComponent extends PlatformWidgetComponent implements OnInit {
  request: PriceRequestsDto = {
    newRequests: 0,
    inProgressRequests: 0,
    upgradeOpenRequests: 0,
    upgradeInProgressRequests: 0,
  };

  description: string;
  newRequests: { count: number; label: string };
  inProgressRequests: { count: number; label: string };

  private readonly _loading: Subject<boolean> = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean> = this._loading.asObservable();

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly priceRequestService: PriceRequestService,
    private readonly snackbarService: SnackbarService
  ) {
    super();

    this.description = this.translocoService.translate('platformWidget.admin.priceRequests.description');
    this.newRequests = {
      count: 0,
      label: this.translocoService.translate('platformWidget.admin.priceRequests.requestOpen'),
    };
    this.inProgressRequests = {
      count: 0,
      label: this.translocoService.translate('platformWidget.admin.priceRequests.requestInProgress'),
    };
  }

  async ngOnInit(): Promise<void> {
    await this.loadPriceRequests();
  }

  async loadPriceRequests(): Promise<void> {
    try {
      this.request = await firstValueFrom(this.priceRequestService.getPriceRequestsCount());

      this.newRequests = { ...this.newRequests, count: this.request.newRequests };
      this.inProgressRequests = { ...this.inProgressRequests, count: this.request.inProgressRequests };

      this.setWidgetDescription();

      this._loading.next(false);
    } catch (error) {
      this.snackbarService.showErrorSnackbarWithTransloco('platformWidget.admin.platformRequests.cannotLoadWidgetData');
      console.error('Error loading price request data:', error);
    }
  }

  setWidgetDescription(): void {
    if (this.request.upgradeInProgressRequests === 0 && this.request.upgradeOpenRequests === 0) {
      this.description = this.translocoService.translate(
        'platformWidget.admin.priceRequests.descriptionWithoutUpgrade'
      );
    }
  }
}
